/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import Dropdown from "./dropdown";
import { v4 as uuidV4 } from "uuid";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "center",
  padding: "8px",
  fontWeight: 400,
};

const titleStyle = {
  textAlign: "right",
  paddingRight: 20,
  background: "#ddeff3",
  fontWeight: "bold",
};

const Th = ({ children, styles, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, fontSize: "16px", ...styles }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px" }}>
      {children}
    </th>
  );
};

const resourceOption = [
  {
    value: "sắt",
    label: "Sắt",
  },
  {
    value: "sắt kim loại",
    label: "Sắt kim loại",
  },
  {
    value: "quặng Manhetit (có từ tính)",
    label: "Quặng Manhetit (có từ tính)",
  },
  {
    value: "quặng Limonit (không từ tính)",
    label: "Quặng Limonit (không từ tính)",
  },
];
const DVTOption = [
  {
    value: "kg",
    label: "Kg",
  },
  {
    value: "tấn",
    label: "Tấn",
  },
  {
    value: "thùng",
    label: "Thùng",
  },
  {
    value: "kwh",
    label: "KWh",
  },
  {
    value: "m3",
    label: "M3",
  },
  {
    value: "lít",
    label: "Lít",
  },
  {
    value: "cây",
    label: "Cây",
  },
];

const tableData = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    goodsName: {
      type: "select",
      value: null,
      bg: false,
    },
    DVT: {
      type: "input",
      value: null,
      bg: true,
    },
    quantity: {
      type: "input",
      value: 0,
      bg: false,
    },
    percent: {
      type: "input",
      value: 0,
      bg: false,
    },
    taxLevel: {
      type: "input",
      value: 0,
      bg: false,
    },
    taxMustPaid: {
      type: "input",
      value: 0,
      bg: false,
    },
  },
];

export default function ProtectResourceTable({ formData, setFieldValue }) {
  const [data, setData] = useState(tableData);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const addNewRow = () => {
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: uuidV4(),
        bg: true,
      },
      goodsName: {
        type: "select",
        value: null,
        bg: false,
      },
      DVT: {
        type: "input",
        value: null,
        bg: true,
      },
      quantity: {
        type: "input",
        value: 0,
        bg: false,
      },
      percent: {
        type: "input",
        value: 0,
        bg: false,
      },
      taxLevel: {
        type: "input",
        value: 0,
        bg: false,
      },
      taxMustPaid: {
        type: "input",
        value: 0,
        bg: false,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                STT
              </Th>
              <Th style={{ textAlign: "center" }} styles={{ width: "25%" }} rowSpan="2">
                Tên hàng hóa
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="3">
                Sản lượng tính thuế
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Mức thuế
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế BVMT phải nộp trong kỳ
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>Đơn vị tính</Th>
              <Th style={{ textAlign: "center" }}>Sản lượng</Th>
              <Th style={{ textAlign: "center" }}>Tỷ lệ phần trăm(%) tính thuế</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}>(7)=(4)x(5)x(6)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td className="toggle-button" style={{ textAlign: "center" }}>
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete("item1", row.id.value)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.goodsName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.goodsName.bg ? (
                      row.goodsName.value
                    ) : row.goodsName?.type === "select" ? (
                      <SelectTable
                        name="resource"
                        id={row.id.value}
                        option={resourceOption}
                        onChange={handleChange}
                      />
                    ) : (
                      row.goodsName.value
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.DVT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.DVT?.type !== "input" ? (
                      row.DVT.value
                    ) : (
                      // <InputTable
                      //   type={"number"}
                      //   id={row.id.value}
                      //   name="DVT"
                      //   value={row.DVT.value}
                      //   onChange={handleChange}
                      //   disable={true}
                      // />
                      <div></div>
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantity?.type !== "input" ? (
                      row.quantity.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="quantity"
                        value={row.quantity.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.percent.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.percent?.type !== "input" ? (
                      row.percent.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="percent"
                        value={row.percent.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxLevel.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxLevel?.type !== "input" ? (
                      row.taxLevel.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="taxLevel"
                        value={row.taxLevel.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxMustPaid.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxMustPaid?.type !== "input" ? (
                      row.taxMustPaid.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="taxMustPaid"
                        value={row.taxMustPaid.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                colspan="6"
                row={{ bold: true }}
                style={{
                  textAlign: "left",
                  // paddingRight: "78px",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng
              </Td>
              <Td
                colspan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={"total"}
                  type={"number"}
                  name="total"
                  value={0}
                  disable={true}
                  // onChange={handleChange}
                />
              </Td>
            </tr>
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, fields, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      type={fields}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
